import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog"

export type PreviewImage = {
  url: string
  title?: string | null
  fileName?: string | null
}

interface ImagePreviewDialogProps {
  image: PreviewImage | null
  onClose: () => void
}

export function ImagePreviewDialog({ image, onClose }: ImagePreviewDialogProps) {
  return (
    <Dialog open={!!image} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl p-0 overflow-hidden">
        <DialogTitle className="sr-only">
          {image?.title || image?.fileName || "画像プレビュー"}
        </DialogTitle>
        {image && (
          <div className="bg-slate-950 p-4">
            <img
              src={image.url}
              alt={image.title || image.fileName || ""}
              className="max-h-[80vh] w-full rounded-md object-contain"
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
